import { useEffect, useState } from "react";

import { Dialog } from "primereact/dialog";
import { Card } from "primereact/card";
import TopicCreate from "./TopicCreate";
import { ITopic } from "./Topic.model";
import { TopicService } from "../../service/Topic/topic.service";
import TopicList from "./TopicList";

const Topic = () => {
  const [topicDialog, setTopicDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<ITopic[]>([]);

  const openNew = () => {
    setTopicDialog(true);
  };

  const hideDialog = () => {
    setTopicDialog(false);
  };

  useEffect(() => {
    loadTopics();
  }, []);

  const loadTopics = async () => {
    setLoading(true);
    const res = await TopicService.getTopics();
    const sortedData = [...res.data].sort((a, b) => b.id - a.id);
    setData(sortedData);
    setLoading(false);
  };

  return (
    <>
      <Card>
        <Dialog
          visible={topicDialog}
          header={"Topic Details"}
          modal
          onHide={() => hideDialog()}
          style={{ width: "50vw" }}>
          <TopicCreate
            setTopicDialog={setTopicDialog}
            loadTopics={loadTopics}
          />
        </Dialog>
        <TopicList
          openNew={openNew}
          loading={loading}
          data={data}
          loadTopics={loadTopics}
        />
      </Card>
    </>
  );
};

export default Topic;
